<div
    class="avoid-page-break w-full h-full"
    [ngClass]="isStatisticScreen() ? 'bg-background rounded-xl' : ''">
    <div class="flex flex-col w-full h-full p-2">
        @if (title()) {
            <div
                class="text-base font-semibold leading-tight pr-5 mx-3 my-2"
                [class.text-center]="isTitleCentred()"
                [class.text-start]="!isTitleCentred()">
                {{ title() }}
            </div>
        }
        @if (subtitle()) {
            <div class="ml-3">
                <p class="text-sm text-on-surface">
                    {{ subtitle() }}
                </p>
            </div>
        }
        <div class="flex-grow flex flex-col justify-center">
            <ng-content />
        </div>
    </div>
</div>
